/* Goloka V3 collection: behaviour layered on Dawn's facets.js (AJAX filtering stays in facets.js). */
(function () {
  if (window.__v3Collection) return;
  window.__v3Collection = true;

  var POP = 'details.facets__disclosure[open]';

  function closePops(except) {
    document.querySelectorAll(POP).forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  // One popover at a time; close on outside click.
  document.addEventListener('click', function (e) {
    var t = e.target;
    var done = t.closest && t.closest('[data-v3-done]');
    if (done) {
      var d = done.closest('details');
      if (d) {
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.focus();
      }
      return;
    }
    var inside = t.closest && t.closest('details.facets__disclosure');
    if (inside && t.closest('summary')) {
      // Dawn toggles after this click; close the others now.
      closePops(inside);
      return;
    }
    if (!inside) closePops(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector(POP);
    if (!open) return;
    open.removeAttribute('open');
    var s = open.querySelector('summary');
    if (s) s.focus();
  });

  // Keep every "Show N results" label in step with the live product count.
  function syncCounts() {
    var src = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    if (!src) return;
    var m = (src.textContent || '').match(/\d+/);
    if (!m) return;
    document.querySelectorAll('[data-v3-count]').forEach(function (el) {
      if (el.textContent !== m[0]) el.textContent = m[0];
    });
  }
  function watch() {
    ['ProductCountDesktop', 'ProductCount'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) new MutationObserver(syncCounts).observe(el, { childList: true, characterData: true, subtree: true });
    });
    syncCounts();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
